import React, { useState, useCallback, useEffect, useRef } from "react";

import Layout from "../Component/Layout";
import Inputbox from "../Component/Inputbox";
import {
  BiPlus,
  BiMinus,
  BiChevronDown,
  BiSolidCloudUpload,
  BiTrash,
} from "react-icons/bi";
import Button from "../Component/Button";
import { showToast } from "../helper/Toster";
import axios from "axios";
import REACT_APP_API_URL from "../utils/constant";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import Select from "react-select";
import Instagram from "../assets/Image/instagram.png";
import Youtube from "../assets/Image/youtube.png";
import Tiktok from "../assets/Image/tik-tok.png";
import Facebook from "../assets/Image/facebook.png";
import Twitter from "../assets/Image/twitter.png";

function MyVerticallyCenteredModal({ show, onHide, onAddClub }) {
  const [clubName, setClubName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (clubName.trim() !== "") {
      onAddClub(clubName);
      setClubName("");
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h5 className="m-0">Add Club</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="">
            <label htmlFor="mainClub" className="form-label fs-6">
              Main Club
            </label>
            <input
              type="text"
              placeholder="Enter main club"
              className="form-control"
              value={clubName}
              onChange={(e) => setClubName(e.target.value)}
              required
            />
          </div>
          <Button type="submit" className="px-5 mt-4">
            Add
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}

// function AddSubClubModal({ show, onHide, onAddSubClub, mainClub }) {
//   const [subClubName, setSubClubName] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (subClubName.trim() !== "") {
//       onAddSubClub(mainClub, subClubName);
//       setSubClubName("");
//       onHide();
//     }
//   };

//   return (
//     <Modal show={show} onHide={onHide} size="md" centered>
//       <Modal.Header closeButton>
//         <Modal.Title id="contained-modal-title-vcenter">
//           <h5 className="m-0">Add Partner Clubs</h5>
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <form onSubmit={handleSubmit}>
//           <div className="">
//             <label htmlFor="subClub" className="form-label fs-6">
//               Club
//             </label>
//             <input
//               type="text"
//               placeholder="Enter club"
//               className="form-control"
//               value={subClubName}
//               onChange={(e) => setSubClubName(e.target.value)}
//               required
//             />
//           </div>
//           <Button type="submit" className="px-5 mt-4">
//             Add
//           </Button>
//         </form>
//       </Modal.Body>
//     </Modal>
//   );
// }

const AddSubClubModal = ({ show, onHide, onAddSubClub }) => {
  const [desc, setDesc] = useState("");
  const [url, setUrl] = useState("");

  const handleSubmit = () => {
    onAddSubClub(desc, url);
    setDesc("");
    setUrl("");
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Subclub</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Subclub description"
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
        />
        <input
          type="url"
          className="form-control mb-2"
          placeholder="Subclub URL (optional)"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleSubmit}>Add</Button>
      </Modal.Footer>
    </Modal>
  );
};

const AddExplore = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [subClubModalShow, setSubClubModalShow] = useState(false);
  const [clubs, setClubs] = useState([{ name: "", url: "", subClubs: [] }]);

  const [subClubs, setSubClubs] = useState({});
  const [stay, setStay] = useState([{ description: "" }]);
  const [activity, setActivity] = useState([{ description: "" }]);
  const [thumbnail, setThumbnail] = useState(null);
  const [trip_name, setTripName] = useState("");
  const [location, setLocation] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [socialLinks, setSocialLinks] = useState({});
  const locationInputRef = useRef(null);
  const [selectedClubIndex, setSelectedClubIndex] = useState(null);
  const [errors, setErrors] = useState({
    trip_name: "",
    description: "",
    socialLinks: "",
    selectedPrice: "",
  });

  <gmpx-place-autocomplete
    id="place-autocomplete"
    placeholder="Enter a location"
  ></gmpx-place-autocomplete>;

  const validateForm = () => {
    const newErrors = {
      trip_name: "",
      description: "",
      selectedPrice: "",
      socialLinks: "",
    };
    let isValid = true;

    if (!trip_name.trim()) {
      newErrors.trip_name = "Trip name is required";
      isValid = false;
    }

    if (!description.trim()) {
      newErrors.description = "Description is required";
      isValid = false;
    }

    if (!selectedPrice) {
      newErrors.selectedPrice = "Please select a price level";
      isValid = false;
    }

    if (selectedOptions.length === 0) {
      newErrors.socialLinks = "Select at least one social platform";
      isValid = false;
    } else {
      const missingLinks = selectedOptions.filter(
        (opt) => !socialLinks[opt.value]?.trim()
      );
      if (missingLinks.length > 0) {
        newErrors.socialLinks = `Missing link(s) for: ${missingLinks
          .map((opt) => opt.value)
          .join(", ")}`;
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  useEffect(() => {
    if (window.google) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        locationInputRef.current,
        {
          types: ["geocode"], // You can change this to `"geocode"` if you want more general addresses
        }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place && place.formatted_address) {
          setLocation(place.formatted_address);
        } else if (place.name) {
          setLocation(place.name);
        }
      });
    }
  }, []);

  // Club management functions
  // const addClub = (clubName) => {
  //   setClubs([...clubs, clubName]);
  // };
  const addClub = (clubName, url = "") => {
    setClubs([...clubs, { name: clubName, url, subClubs: [] }]);
  };

  const removeClub = (index) => {
    const updatedClubs = clubs.filter((_, idx) => idx !== index);
    const updatedSubClubs = { ...subClubs };
    delete updatedSubClubs[clubs[index]];
    setClubs(updatedClubs);
    setSubClubs(updatedSubClubs);
  };

  // const addSubClub = (mainClub, subClubName) => {
  //   setSubClubs({
  //     ...subClubs,
  //     [mainClub]: [...(subClubs[mainClub] || []), subClubName],
  //   });
  // };

  const addSubClub = (clubIndex, subClubDesc, subClubUrl = "") => {
    setClubs((prevClubs) =>
      prevClubs.map((club, idx) =>
        idx === clubIndex
          ? {
              ...club,
              subClubs: [
                ...(club.subClubs || []),
                { description: subClubDesc, url: subClubUrl },
              ],
            }
          : club
      )
    );
  };

  const removeSubClub = (clubIndex, subIndex) => {
    setClubs((prevClubs) =>
      prevClubs.map((club, idx) =>
        idx === clubIndex
          ? {
              ...club,
              subClubs: club.subClubs.filter((_, i) => i !== subIndex),
            }
          : club
      )
    );
  };

  // const removeSubClub = (mainClub, subIndex) => {
  //   setSubClubs({
  //     ...subClubs,
  //     [mainClub]: subClubs[mainClub].filter((_, idx) => idx !== subIndex),
  //   });
  // };

  const handleClubChange = (index, key, value) => {
    const updatedClubs = [...clubs];
    updatedClubs[index][key] = value;
    setClubs(updatedClubs);
  };

  const handleSubClubChange = (clubIndex, subIndex, key, value) => {
    const updated = [...clubs];
    updated[clubIndex].subClubs[subIndex][key] = value;
    setClubs(updated);
  };

  // Stay management
  const addStay = () => {
    setStay([...stay, { description: "" }]);
  };

  const removeStay = (index) => {
    setStay(stay.filter((_, i) => i !== index));
  };

  // Activity management
  const addActivity = () => {
    setActivity([...activity, { description: "" }]);
  };

  const removeActivity = (index) => {
    setActivity(activity.filter((_, i) => i !== index));
  };

  // Image handling with dropzone
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (images.length + acceptedFiles.length <= 6) {
        const newImages = acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        );
        setImages((prevImages) => [...prevImages, ...newImages]);
      } else {
        showToast("You can only upload a maximum of 6 images.", "error");
      }
    },
    [images]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*",
    maxFiles: 6,
    maxSize: 2097152,
  });

  const removeImage = (fileToRemove) => {
    setImages(images.filter((file) => file !== fileToRemove));
    URL.revokeObjectURL(fileToRemove.preview);
  };

  // Social links handling
  const options = [
    { value: "Facebook", label: "Facebook", icon: Facebook },
    { value: "Youtube", label: "Youtube", icon: Youtube },
    { value: "Tiktok", label: "Tiktok", icon: Tiktok },
    { value: "Instagram", label: "Instagram", icon: Instagram },
    { value: "Twitter", label: "Twitter", icon: Twitter },
  ];

  const handleSelectChange = (selected) => {
    setSelectedOptions(selected || []);

    const updatedLinks = { ...socialLinks };
    selected.forEach((option) => {
      if (!updatedLinks[option.value]) {
        updatedLinks[option.value] = "";
      }
    });

    Object.keys(updatedLinks).forEach((key) => {
      if (!selected.some((option) => option.value === key)) {
        delete updatedLinks[key];
      }
    });

    setSocialLinks(updatedLinks);
  };

  const handleInputChange = (platform, value) => {
    setSocialLinks({
      ...socialLinks,
      [platform]: value,
    });
  };

  // Form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const formData = new FormData();

      // Price mapping
      const priceMap = {
        $: 1,
        $$: 2,
        $$$: 3,
      };
      const numericPrice = priceMap[selectedPrice] || 0;

      // Add simple fields
      formData.append("trip_name", trip_name);
      formData.append("location", location);
      formData.append("category", category);
      formData.append("description", description);
      formData.append("price", numericPrice);

      // Add thumbnail
      if (thumbnail) {
        formData.append("thumbnail", thumbnail);
      }

      // Add images
      images.forEach((img) => {
        formData.append("explore", img);
      });

      // formData.append("clubs", JSON.stringify(clubsData));
      formData.append("clubs", JSON.stringify(clubs));

      // Add stays
      formData.append(
        "stay",
        JSON.stringify(stay.map((item) => ({ description: item.description })))
      );

      // Add activities
      formData.append(
        "activities",
        JSON.stringify(
          activity.map((item) => ({ description: item.description }))
        )
      );

      // Prepare social links
      const socialLinksData = selectedOptions.map((option) => ({
        title: option.value,
        link: socialLinks[option.value] || "",
      }));
      formData.append("socialLinks", JSON.stringify(socialLinksData));

      // Log form data for debugging
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await axios.post(
        `${REACT_APP_API_URL}/add-Explore`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );
      console.log("response", response.data.data);

      if (response.data.code === 200) {
        showToast("success", "Explore added successfully");
        navigate(`/explore/detail/${response.data.data.id}`);
      } else {
        showToast(response.data.message || "Error adding explore", "error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast(
        "error",
        error.response?.data?.message || "Error submitting form"
      );
    }
  };

  return (
    <Layout>
      <div className="row">
        <div className="col-12">
          <Link to="/explore" className="btn btn-primary px-5">
            Back
          </Link>
          <div className="card mt-4">
            <div className="card-body">
              <form onSubmit={handleFormSubmit}>
                <div className="row">
                  {/* Thumbnail Upload */}
                  <div className="col-12">
                    <label htmlFor="thumbnail" className="form-label fs-6">
                      Upload Thumbnail
                    </label>
                    <Inputbox
                      type="file"
                      accept="image/*"
                      className="form-control"
                      id="thumbnail"
                      onChange={(e) => setThumbnail(e.target.files[0])}
                      fileName={thumbnail?.name}
                      required
                    />
                  </div>

                  {/* Image Upload with Dropzone */}
                  <div className="col-12 mt-4">
                    <label htmlFor="stays" className="form-label fs-6">
                      Upload Images
                    </label>
                    <div {...getRootProps()} className="dropzone-box">
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here ...</p>
                      ) : (
                        <p className="m-0 text-center">
                          <BiSolidCloudUpload className="fs-1" />
                          <br /> Upload Image
                        </p>
                      )}
                    </div>
                    <div className="image-preview-container d-flex gap-2 align-items-center flex-wrap mt-3">
                      {images.map((file, index) => (
                        <div
                          key={index}
                          className="image-preview position-relative"
                          style={{ width: "100px" }}
                        >
                          <img
                            src={file.preview}
                            alt={`preview ${index}`}
                            className="img-thumbnail"
                            style={{
                              width: "100%",
                              height: "100px",
                              objectFit: "cover",
                            }}
                          />
                          <button
                            type="button"
                            className="position-absolute top-0 end-0 bg-danger text-white p-1 rounded"
                            style={{ transform: "translate(30%, -30%)" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              removeImage(file);
                            }}
                          >
                            <BiTrash />
                          </button>
                        </div>
                      ))}
                    </div>
                    <small className="text-muted">
                      Maximum 6 images allowed
                    </small>
                  </div>

                  {/* Basic Information */}
                  <div className="col-12 mt-4">
                    <label htmlFor="tripname" className="form-label fs-6">
                      Name
                    </label>
                    <Inputbox
                      type="text"
                      placeholder="Enter name"
                      className="form-control"
                      id="tripname"
                      value={trip_name}
                      onChange={(e) => setTripName(e.target.value)}
                      required
                    />
                    {errors.trip_name && (
                      <small className="text-danger">{errors.trip_name}</small>
                    )}
                  </div>

                  <div className="col-12 mt-4">
                    <label htmlFor="triplocation" className="form-label fs-6">
                      Location
                    </label>
                    <input
                      type="text"
                      placeholder="Enter location"
                      className="form-control"
                      id="triplocation"
                      ref={locationInputRef}
                      value={location}
                      onChange={(e) => setLocation(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12 mt-4 position-relative">
                    <label htmlFor="tripcategory" className="form-label fs-6">
                      Category
                    </label>
                    <select
                      name="tripcategory"
                      id="tripcategory"
                      className="form-control"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      required
                    >
                      <option value="" disabled hidden>
                        Select category
                      </option>
                      <option value="city">City</option>
                      <option value="resort">Resort</option>
                    </select>
                    <BiChevronDown
                      className="position-absolute fs-4"
                      style={{ right: 26, top: 35 }}
                    />
                  </div>

                  {/* Clubs Section */}
                  <div className="col-12 mt-4 ">
                    <div className="position-relative">
                      <label htmlFor="clubs" className="form-label fs-6">
                        Clubs
                      </label>
                      {clubs.map((club, index) => (
                        <div key={index} className="mb-4 ">
                          <div className="position-relative">
                            <input
                              type="text"
                              className="form-control mb-2"
                              placeholder="Club Name"
                              value={club.name}
                              onChange={(e) =>
                                handleClubChange(index, "name", e.target.value)
                              }
                            />
                            <a
                              href="#"
                              className="position-absolute end-0 top-0 remove-event"
                              variant="outline-danger"
                              onClick={() => removeClub(index)}
                            >
                              <BiMinus className="bx" />
                            </a>
                          </div>
                          <input
                            type="url"
                            className="form-control mb-2"
                            placeholder="Club URL"
                            value={club.url}
                            onChange={(e) =>
                              handleClubChange(index, "url", e.target.value)
                            }
                          />
                          <div className="d-flex justify-content-between">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary me-2 mt-1"
                              variant="outline-success"
                              onClick={() => {
                                setSelectedClubIndex(index);
                                setSubClubModalShow(true);
                              }}
                            >
                              <BiPlus className="bx" /> Add Subclub
                            </button>
                          </div>

                          {club.subClubs && club.subClubs.length > 0 && (
                            <div className="mt-3 ps-3">
                              {club.subClubs.map((sub, subIndex) => (
                                <div
                                  key={subIndex}
                                  className="mb-2 d-flex align-items-center gap-2"
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={sub.description}
                                    placeholder="Subclub Description"
                                    readOnly
                                  />
                                  <input
                                    type="url"
                                    className="form-control"
                                    value={sub.url}
                                    placeholder="Subclub URL"
                                    readOnly
                                  />
                                  <button
                                    style={{ height: 44, paddingInline: 14 }}
                                    className="btn btn-primary"
                                    variant="danger"
                                    size="sm"
                                    onClick={() =>
                                      removeSubClub(index, subIndex)
                                    }
                                  >
                                    <BiMinus className="bx" />
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}

                      <p
                        className="position-absolute text-primary border-0 bg-transparent end-0 top-0 cursor-pointer"
                        variant="primary"
                        onClick={() =>
                          setClubs([
                            ...clubs,
                            { name: "", url: "", subClubs: [] },
                          ])
                        }
                      >
                        <BiPlus className="bx" /> Add Club
                      </p>
                    </div>
                  </div>
                  {/* Stays Section - Only for City */}
                  {category === "city" && (
                    <div className="col-12 mt-4">
                      <div className="position-relative course-field">
                        <label htmlFor="stays" className="form-label fs-6">
                          Stays
                        </label>
                        {stay.map((item, index) => (
                          <div key={index} className="mb-2 position-relative">
                            <Inputbox
                              type="text"
                              placeholder="Enter stay"
                              className="form-control"
                              value={item.description}
                              onChange={(e) => {
                                const newStay = [...stay];
                                newStay[index].description = e.target.value;
                                setStay(newStay);
                              }}
                            />
                            <p
                              className="position-absolute top-0 end-0 remove-course "
                              style={{ right: "10px", top: "5px" }}
                              onClick={() => removeStay(index)}
                            >
                              <BiMinus className="bx" />
                            </p>
                          </div>
                        ))}
                        <p
                          className="position-absolute top-0 end-0 add-course "
                          style={{
                            right: "10px",
                            top: "5px",
                            color: "#264a2e",
                            cursor: "pointer",
                          }}
                          onClick={addStay}
                        >
                          <BiPlus className="bx" /> Add Stay
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Activities Section */}
                  <div className="col-12 mt-4">
                    <div className="position-relative course-field">
                      <label htmlFor="stays" className="form-label fs-6">
                        Additional Activities
                      </label>
                      {activity.map((item, index) => (
                        <div key={index} className="mb-2 position-relative">
                          <Inputbox
                            type="text"
                            placeholder="Enter activity"
                            className="form-control"
                            value={item.description}
                            onChange={(e) => {
                              const newActivity = [...activity];
                              newActivity[index].description = e.target.value;
                              setActivity(newActivity);
                            }}
                          />
                          <a
                            href="#"
                            className="position-absolute top-0 end-0 remove-course "
                            style={{ right: "10px", top: "5px" }}
                            onClick={() => removeActivity(index)}
                          >
                            <BiMinus className="bx" />
                          </a>
                        </div>
                      ))}

                      <p
                        className="position-absolute top-0 end-0 add-course cursor-pointer text-primary"
                        style={{ right: "10px", top: "5px" }}
                        onClick={addActivity}
                      >
                        <BiPlus className="bx" /> Add Activity
                      </p>
                    </div>
                  </div>

                  {/* Description */}
                  <div className="col-12 mt-4">
                    <label htmlFor="description" className="form-label fs-6">
                      Description
                    </label>
                    <textarea
                      name="description"
                      className="form-control"
                      style={{ resize: "none" }}
                      placeholder="Enter description"
                      rows={6}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      required
                    ></textarea>
                    {errors.description && (
                      <small className="text-danger">
                        {errors.description}
                      </small>
                    )}
                  </div>

                  {/* Price */}
                  <div className="col-12 mt-4">
                    <label htmlFor="Price" className="form-label fs-6">
                      Price
                    </label>
                    <div className="mt-2 d-flex gap-3">
                      <p
                        className={`price-select m-0 btn ${
                          selectedPrice === "$" ? "selected" : ""
                        }`}
                        onClick={() => setSelectedPrice("$")}
                      >
                        $
                      </p>
                      <p
                        className={`price-select m-0 btn ${
                          selectedPrice === "$$" ? "selected" : ""
                        }`}
                        onClick={() => setSelectedPrice("$$")}
                      >
                        $$
                      </p>
                      <p
                        className={`price-select m-0 btn ${
                          selectedPrice === "$$$" ? "selected" : ""
                        }`}
                        onClick={() => setSelectedPrice("$$$")}
                      >
                        $$$
                      </p>
                    </div>
                    {errors.selectedPrice && (
                      <small className="text-danger">
                        {errors.selectedPrice}
                      </small>
                    )}
                  </div>

                  {/* Social Links */}
                  <div className="col-12 mt-4">
                    <div className="position-relative course-field">
                      <label htmlFor="stays" className="form-label fs-6">
                        Social Links
                      </label>
                      <Select
                        isMulti
                        name="socialLinks"
                        options={options}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={handleSelectChange}
                        value={selectedOptions}
                      />

                      {selectedOptions.map((option) => (
                        <div key={option.value} className="input-group mt-3">
                          <span className="input-group-text">
                            <img
                              src={option.icon}
                              height={25}
                              alt={option.label}
                            />
                          </span>
                          <input
                            type="url"
                            className="form-control"
                            placeholder={`Enter ${option.label} link`}
                            value={socialLinks[option.value] || ""}
                            onChange={(e) =>
                              handleInputChange(option.value, e.target.value)
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="row">
                    <div className="col-12">
                      <Button type="submit" className="px-5 mt-4">
                        Upload
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        onAddClub={addClub}
      />

      {/* <AddSubClubModal
        show={subClubModalShow}
        onHide={() => setSubClubModalShow(false)}
        onAddSubClub={addSubClub}
        mainClub={selectedClubForSub}
      /> */}

      <AddSubClubModal
        show={subClubModalShow}
        onHide={() => setSubClubModalShow(false)}
        onAddSubClub={(description, url) => {
          addSubClub(selectedClubIndex, description, url);
          setSubClubModalShow(false);
        }}
      />
    </Layout>
  );
};

export default AddExplore;
